import { useEffect, useState } from 'react';

let cachedSet: Set<string> | null = null;
let inFlight: Promise<Set<string>> | null = null;

export const useDisabledValueChainNames = (): Set<string> => {
  const [names, setNames] = useState<Set<string> | null>(cachedSet);

  useEffect(() => {
    if (names) return;
    if (!inFlight) {
      const base = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) ? process.env.PUBLIC_URL : '';
      const url = `${base}/disabled_value_chains.txt`;
      inFlight = fetch(url, { cache: 'no-cache' })
        .then((res) => (res.ok ? res.text() : ''))
        .then((text) => {
          // Remove potential BOM and normalize newlines
          const normalized = String(text || '').replace(/^\uFEFF/, '');
          const lines = normalized
            .split(/\r?\n/)
            .map((s) => s.trim())
            .filter((s) => s && !s.startsWith('#'));
          cachedSet = new Set(lines);
          return cachedSet;
        })
        .catch(() => new Set());
    }
    inFlight.then((set) => setNames(set));
  }, [names]);

  return names || new Set();
};

